import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { CredentialsService } from '../service/credentials.service';

@Injectable()
export class AuthInterceptorInterceptor implements HttpInterceptor {

  constructor(private credentialsService: CredentialsService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const authToken = this.credentialsService.getAuthToken();

    if (authToken && !this.isAuthenticationRequest(request)) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${authToken}`
        }
      });
    }
    return next.handle(request);
  }

  private isAuthenticationRequest(request: HttpRequest<any>): boolean {
    return request.url.endsWith('/autenticacao/autenticar') && request.method === 'POST';
  }

}
